import React, {useState} from 'react';
import {useAuthProvider, useDataProvider, useLogout, useNotify} from 'react-admin';
import {useSearchParams} from 'react-router-dom';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Box, InputAdornment, Stack, TextField, Typography} from '@mui/material';

import {Button} from '../../components';

export const AdminNewPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [newPassword, setPassword] = useState('');

    const auth = useAuthProvider();
    const [searchParams] = useSearchParams();
    const dataProvider = useDataProvider();

    const logout = useLogout();
    const notify = useNotify();

    const email = searchParams.get('email');
    const token = searchParams.get('token');

    const handleLoginClick = () => {
        console.log(auth.getToken());
        if (auth.getToken()) {
            logout();
        }

        setTimeout(() => {
            location.href = location.origin;
        }, 1000);
    };

    const handleSubmit = async () => {
        setIsLoading(true);

        try {
            const data = {
                newPassword,
                token
            };

            await dataProvider.post(`forgot-password/${encodeURIComponent(email || '')}/reset`, {data});
            setIsSubmitted(true);

            notify('Password has been changed successfully!');
        } catch (error: any) {
            console.log(error.body);
            const message = error.body?.errors?.map((it: {message: string}) => it.message).join(', ');

            notify(`Error: ${message || error.message}`, {type: 'warning'});
        }

        setIsLoading(false);
    };

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'1594\' height=\'968\' fill=\'none\' viewBox=\'0 0 1594 968\'%3E%3Cpath fill=\'url(%23paint0_linear_8762_30421)\' fill-opacity=\'.1\' fill-rule=\'evenodd\' d=\'M402.593 375.545c38.171 134.932 121.84 252.874 236.832 333.845 66.603 47.03 141.943 80.225 221.508 97.605 157.537 33.98 321.727 4.377 456.587-82.317 134.87-86.694 229.41-223.417 262.93-380.21 33.51-156.797 3.27-320.8839-84.12-456.317-87.38-135.434-224.78-231.166-382.08-266.23-137.243-30.022-280.336-11.866-405.042 51.39-124.705 63.256-223.354 167.723-279.232 295.7007-55.881 127.9812-65.553 271.6003-27.383 406.5333ZM961.058-104.92c74.112-5.613 148.052 14.6223 209.212 57.2466C1239.96.6254 1287.75 74.4223 1303.15 157.492c13.74 72.998 1.68 148.31-34.12 213.082-35.79 64.772-93.1 114.986-162.14 142.069-69.04 27.083-145.531 29.359-216.414 6.434-70.879-22.923-131.759-69.622-172.244-132.128-40.483-62.498-58.058-136.932-49.728-210.583 8.332-73.654 42.052-141.9585 95.409-193.2615C817.268-68.195 886.948-99.3066 961.058-104.92ZM95.7529 1076.62c43.0231 67.43 98.8931 125.82 164.4081 171.85l-.027.03c65.462 46.11 139.303 78.96 217.3 96.67 78 17.71 158.626 19.93 237.27 6.54 78.642-13.39 153.759-42.14 221.058-84.59 67.288-42.45 125.448-97.77 171.138-162.81l-113.217-79.64c-30.256-21.28-66.182-33.002-103.085-33.623-36.896-.622-73.047 9.883-103.717 30.143-53.748 35.36-117.039 53.68-181.63 52.56-64.589-1.11-127.476-21.61-180.468-58.82-52.992-37.209-93.623-89.405-116.605-149.776-22.98-60.375-27.24-126.129-12.226-188.691 17.749-73.342-10.922-150.356-73.007-194.03L109.728 402.79c-45.7704 64.979-78.188 138.409-95.4 216.093C-2.884 696.566-4.5511 776.977 9.4203 855.52c13.9711 78.542 43.3094 153.67 86.3326 221.1Z\' clip-rule=\'evenodd\'/%3E%3Cdefs%3E%3ClinearGradient id=\'paint0_linear_8762_30421\' x1=\'1335.32\' x2=\'260.136\' y1=\'-279.929\' y2=\'1248.51\' gradientUnits=\'userSpaceOnUse\'%3E%3Cstop stop-color=\'%237E5FFF\'/%3E%3Cstop offset=\'.3542\' stop-color=\'%233C94F7\'/%3E%3Cstop offset=\'.6979\' stop-color=\'%237CF2D0\'/%3E%3Cstop offset=\'1\' stop-color=\'%2367DD42\'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',

            }}
        >
            <Stack
                direction="column"
                spacing={2}
                sx={{
                    p: 4,
                    background: 'white',
                    border: '1px solid #ddd',
                    borderRadius: 4,
                    minWidth: 300,
                    minHeight: 300,
                }}
            >
                <img src="assets/images/logo.svg" width={200}/>
                <br/>
                <Typography paragraph variant="h6">{isSubmitted ? 'Password has been changed successfully!' : 'Set password'}</Typography>

                {!isSubmitted && (
                    <TextField
                        disabled={isLoading}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end" sx={{cursor: 'pointer'}} onClick={() => setIsVisible(!isVisible)}>
                                    {isVisible ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                                </InputAdornment>
                            ),
                        }}
                        type={isVisible ? 'text' : 'password'}
                        variant="outlined"
                        onChange={(event) => setPassword(event.target.value)}
                    />
                )}

                <br/>
                <br/>

                {isSubmitted ? (
                    <Button
                        color="primary"
                        disabled={isLoading}
                        variant="contained"
                        onClick={handleLoginClick}
                    >Log in</Button>
                ) : (
                    <Button
                        color="primary"
                        disabled={isLoading}
                        variant="contained"
                        onClick={handleSubmit}
                    >Set Password</Button>
                )}

            </Stack>
        </Box>
    );
};